// src/scenes/contracts/ContractFormPage/GarantiasTab.jsx
import {
  Box,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useTranslation } from '../../../hooks/useTranslation';
import { greenColor } from '../../../config/colors';

const fieldLabelSx = {
  fontSize: '11px',
  fontWeight: 600,
  color: '#9e9e9e',
  mb: 0.5,
  letterSpacing: '0.5px',
};

const selectSx = {
  backgroundColor: '#fff',
  fontSize: '13px',
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e0e0e0' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#bdbdbd' },
};

const GarantiasTab = ({ formData, onChange, options }) => {
  const { t } = useTranslation();
  const s = 'contractForm.garantias';

  const garantias = formData.garantias ?? [{ id: Date.now(), value: '' }];

  const handleChange = (index, value) => {
    const updated = garantias.map((g, i) => (i === index ? { ...g, value } : g));
    onChange({ garantias: updated });
  };

  const handleAdd = () => {
    onChange({ garantias: [...garantias, { id: Date.now(), value: '' }] });
  };

  const handleRemove = (index) => {
    const updated = garantias.filter((_, i) => i !== index);
    onChange({ garantias: updated.length ? updated : [{ id: Date.now(), value: '' }] });
  };

  return (
    <Box>
      <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 2, p: 2.5 }}>
        <Typography sx={{ fontWeight: 700, fontSize: '13px', mb: 2, letterSpacing: '0.5px' }}>
          {t(`${s}.section`)}
        </Typography>

        {garantias.map((g, index) => (
          <Box key={g.id} sx={{ mb: 2 }}>
            <Typography sx={fieldLabelSx}>{t(`${s}.label`)}</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <FormControl fullWidth size="small">
                <Select
                  value={g.value}
                  onChange={(e) => handleChange(index, e.target.value)}
                  displayEmpty
                  sx={selectSx}
                >
                  <MenuItem value="" sx={{ fontSize: '13px' }}>
                    <em style={{ color: '#9e9e9e', fontStyle: 'normal' }}>
                      {t(`${s}.selectGuarantee`)}
                    </em>
                  </MenuItem>
                  {(options?.garantias ?? []).map((gk) => (
                    <MenuItem key={gk.id} value={gk.id} sx={{ fontSize: '13px' }}>
                      {gk.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {garantias.length > 1 && (
                <IconButton
                  size="small"
                  onClick={() => handleRemove(index)}
                  sx={{ color: '#ef5350', flexShrink: 0 }}
                >
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              )}
            </Box>
          </Box>
        ))}

        <Typography
          onClick={handleAdd}
          sx={{
            fontSize: '13px',
            color: greenColor,
            fontWeight: 600,
            cursor: 'pointer',
            mt: 1,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          {t(`${s}.addGuarantee`)}
        </Typography>
      </Box>
    </Box>
  );
};

export default GarantiasTab;
